import { render, staticRenderFns } from "./TopUpRequestDetails.vue?vue&type=template&id=1163251e&"
import script from "./TopUpRequestDetails.vue?vue&type=script&lang=js&"
export * from "./TopUpRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports